import { clamp } from '@helpers/utils';
import { AnimatePresence } from 'framer-motion';
import * as React from 'react';
import { useFirstMountState } from 'react-use';
import CountdownTimer from '../CountdownTimer/CountdownTimer';
import ImageBanner from '../ImageBanner/ImageBanner';
import VideoBanner from '../VideoBanner/VideoBanner';
import S from './CountdownBanner.styles';
const CountdownBanner = ({ text, countdownEndDate, countdownUrl, cta, images, videos, currentIndex, maxIndex, onTimerEnd, }) => {
    const isFirstMount = useFirstMountState();
    const [timeRemaining, setTimeRemaining] = React.useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    React.useEffect(() => {
        if (!countdownEndDate) {
            return;
        }
        const calculateTimeRemaining = () => {
            const endTime = new Date(countdownEndDate).getTime();
            const currentTime = new Date().getTime();
            const remainingTime = endTime - currentTime;
            if (remainingTime < 0) {
                return setTimeRemaining({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                });
            }
            const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
            const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
            setTimeRemaining({
                days,
                hours,
                minutes,
                seconds,
            });
        };
        calculateTimeRemaining();
        const timerId = setInterval(calculateTimeRemaining, 1000);
        return () => clearInterval(timerId);
    }, [countdownEndDate]);
    React.useEffect(() => {
        if (!isFirstMount &&
            timeRemaining.days === 0 &&
            timeRemaining.hours === 0 &&
            timeRemaining.minutes === 0 &&
            timeRemaining.seconds < 59) {
            onTimerEnd(clamp(currentIndex + 1, maxIndex));
        }
    }, [timeRemaining]);
    return (React.createElement(S.Container, null,
        videos ? (React.createElement(VideoBanner, { videos: videos, images: images })) : images ? (React.createElement(ImageBanner, { images: images })) : null,
        React.createElement(AnimatePresence, null, !isFirstMount &&
            timeRemaining.days === 0 &&
            timeRemaining.hours === 0 &&
            timeRemaining.minutes === 0 &&
            timeRemaining.seconds < 59 ? null : (React.createElement(S.ContentWrapper, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } },
            React.createElement(S.TextWrapper, { ...(countdownUrl
                    ? {
                        as: 'a',
                        href: countdownUrl,
                        title: text,
                    }
                    : {}) },
                text && React.createElement(S.Text, null, text),
                countdownEndDate && (React.createElement(S.Countdown, null,
                    React.createElement(CountdownTimer, { timeRemaining: timeRemaining })))),
            cta && cta.text && cta.url && (React.createElement(S.CtaWrapper, null,
                React.createElement(S.CtaLink, { href: cta.url, target: cta.target ?? '_self' }, cta.text))))))));
};
export default CountdownBanner;
